"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

var _interopRequireWildcard = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var echarts = _interopRequireWildcard(require("echarts"));

var _clipboard = _interopRequireDefault(require("clipboard"));

//
//
//
//
//
//
//
//
// 引入基本模板
var _default = {
  components: {},
  props: {
    id: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      myChartLine: ''
    };
  },
  computed: {},
  watch: {
    chartData: {
      handler: function handler(newVal, oldVal) {
        this.drawLine();
        this.myChartLine.resize();
      },
      deep: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.drawLine();
  },
  methods: {
    resize: function resize() {
      var _this = this;

      // console.log("resize")
      setTimeout(function () {
        _this.myChartLine.resize();
      }, 16);
    },
    drawLine: function drawLine() {
      this.myChartLine = echarts.init(document.getElementById(this.id));
      var id = this.id;
      var that = this;

      if (this.chartData.totalFrame && !this.chartData.xAxisData) {
        this.chartData.xAxisData = [];

        if (!this.chartData.intervalFrame) {
          this.chartData.intervalFrame = 1;
        }

        var i = 0;

        for (i = 0; i < this.chartData.totalFrame;) {
          this.chartData.xAxisData.push(i);
          i += this.chartData.intervalFrame;
        }

        if (this.chartData.totalFrame % this.chartData.intervalFrame) {
          i += this.chartData.intervalFrame;
        }

        if (this.chartData.intervalFrame > 1) {
          console.log('xAxisData', this.chartData.xAxisData);
        }
      }

      var option = {
        animation: false,
        title: {
          text: this.chartData.title && this.chartData.title.text || '',
          x: this.chartData.title && this.chartData.title.x || '3%',
          textStyle: {
            fontSize: 14
          }
        },
        grid: this.chartData.grid || {
          left: '3%',
          right: '4%'
        },
        type: this.chartData.type || 'line',
        tooltip: {
          trigger: 'axis'
        },
        // 图表小标
        legend: {
          data: this.chartData.legenddata
        },
        calculable: true,
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          data: this.chartData.xAxisData,
          splitLine: {
            show: true
          }
        },
        yAxis: {
          type: 'value' // name: this.chartData.yAxisName

        },
        series: this.chartData.seriesdata,
        toolbox: {
          feature: {// dataZoom: {
            //   yAxisIndex: false
            // }
          },
          right: '10%'
        } // dataZoom: [
        //   {
        //     type: 'slider',
        //     show: true,
        //     xAxisIndex: [0]
        //     // start: 1,
        //     // end: 35
        //   }
        //   // {
        //   //   type: 'inside',
        //   //   xAxisIndex: [0],
        //   //   start: 1,
        //   //   end: 35
        //   // }
        // ]

      };

      if (option.type === 'line') {
        option.toolbox.feature.dataZoom = {
          yAxisIndex: false
        };
        option.dataZoom = [{
          type: 'slider',
          show: true,
          xAxisIndex: [0] // start: 1,
          // end: 35

        }, {
          type: 'inside',
          xAxisIndex: [0] // start: 1,
          // end: 35

        }];
      }

      if (_clipboard.default.isSupported()) {
        option.toolbox.feature.myCopyId = {
          show: true,
          title: '复制图标ID',
          icon: 'path://M648.434375 128.66666667H323v94.5h-94.5v661.5h472.5v-94.5h94.5V276.32291667L648.434375 128.66666667zM669.5 853.16666667H260V254.66666667h63v535.5h346.5v63z m94.5-94.5H354.5V160.16666667h280.940625L764 289.31666667V758.66666667z',
          onclick: function onclick() {
            // console.log('#' + id + '-copy', Clipboard.isSupported())
            _clipboard.default.copy(id);

            that.$message.success('复制成功');
          }
        };
      } // console.log('lineChart', JSON.stringify(option), this.chartData)


      this.myChartLine.setOption(option);
      window.addEventListener('resize', function () {
        that.myChartLine.resize();
      });
      window.addEventListener('load', function () {
        that.myChartLine.resize();
      });
      this.myChartLine.resize();
    }
  }
};
exports.default = _default;